<template>
  <div class="common-home-content space_pl space_pr" :class="questions.length > 0?'common-home-content-pb':''" v-show="show">
    <div class="survey-name">
      <input type="text" v-model="survey_name" maxlength="10" placeholder="请输入问诊单名称">
    </div>
    <ul class="questions-ul" v-if="questions.length > 0">
      <li
        v-for="(child, index) in questions"
        :key="index"
      >
        <button class="del-question" @click="handleDeleteQuestion(index)">删除</button>
        <p class="question-index">
          第{{index+1}}题
          <span class="ml10 color" v-if="child.type == 1">单选题</span>
          <span class="ml10 color" v-if="child.type == 2">多选题</span>
          <span class="ml10 color" v-if="child.type == 3">简答题</span>
        </p>
        <p class="question-title">{{child.content}}</p>
        <div class="answer-textarea" v-if="child.type == 3"></div>
        <ul class="options-ul" v-else>
          <li
            v-for="(option, options_index) in child.options"
            :key="options_index"
          >
            <label></label>{{option.content}}
          </li>
        </ul>
        <ul class="operation-ul" v-if="questions.length == 1">
          <li class="offset color" @click="handleEdit(child, index)">编辑</li>
        </ul>
        <ul class="operation-ul" v-else-if="index == 0">
          <li class="offset color" @click="handleEdit(child, index)">编辑</li>
          <li class="offset4 color4" @click="handleSort(index, index+1)">下移</li>
          <li class="offset5 color2" @click="handleSort(index, questions.length-1)">置底</li>
        </ul>
        <ul class="operation-ul" v-else-if="(index+1) == questions.length">
          <li class="offset color" @click="handleEdit(child, index)">编辑</li>
          <li class="offset4 color3" @click="handleSort(index, index-1)">上移</li>
          <li class="offset5 color2" @click="handleSort(index, 0)">置顶</li>
        </ul>
        <ul class="operation-ul" v-else>
          <li class="offset color" @click="handleEdit(child, index)">编辑</li>
          <li class="offset2 color2" @click="handleSort(index, 0)">置顶</li>
          <li class="offset3 color3" @click="handleSort(index, index-1)">上移</li>
          <li class="offset4 color4" @click="handleSort(index, index+1)">下移</li>
          <li class="offset5 color2" @click="handleSort(index, questions.length-1)">置底</li>
        </ul>
      </li>
    </ul>
    <button class="bulid-question-btn" @click="bulidQuestion" v-if="questions.length == 0">新建问题</button>
    <div class="fixed-button" v-else>
      <button @click="bulidQuestion">新建问题</button>
    </div>
  </div>
</template>
<script>
import {_} from 'vue-underscore';
import http from '../../util/heraApiConfig'
import {addBridgeForAndroidWebView} from "sdbridge-android";
export default {
  data() {
    return {
      show: false,
      doctor_id: 1,
      survey_id: '',
      sheet_id: '',
      survey_name: '',
      questions: [],
      survey_value: ''
    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    if (localStorage.getItem('is_new_build_survey_status')){
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "android") {
        this.$appUtils.showAppTrBtn({});
      }
      this.bulidQuestion();
    }else{
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        bridge.callHandler("showTrBtn", {'name': "保存"}, (response) => {
        });
        bridge.callHandler("getUserInfo", "", (response) => {
          this.token = response.token;
          this.doctor_id = response.doctor_id;
        });
        bridge.registerHandler('saveSurvey', (data, responseCallback)=> {
          this.saveSurvey()
        });
        bridge.registerHandler('pageback', (data, responseCallback)=> {
          this.pageback()
        });
      } else if (this.isApp == "android") {
        this.$appUtils.showAppTrBtn({'name': "保存"});
        var user_info = this.$appUtils.appData();
        if (user_info) {
          this.token = user_info.token;
          this.doctor_id = user_info.doctor_id;
        }
      }
      let local_survey_question = localStorage.getItem('local_survey_question') ? JSON.parse(localStorage.getItem('local_survey_question')) : false;
      if(local_survey_question){
        this.survey_name = local_survey_question['survey_name'];
        this.questions = local_survey_question['questions'];
        if(local_survey_question['sheet_id']){
          this.sheet_id = local_survey_question['sheet_id'];
        }
        this.show = true;
      }else{
        this.survey_id = localStorage.getItem('survey_id');
        // alert(this.survey_id+'survey_id')
        if(this.survey_id){
          setTimeout(()=>{
            this.getDate();
          },1000)
        }else{
          this.show = true;
        }
      }
      window.appTrBtnClick = ()=> this.saveSurvey();
    }
    window.appBack = ()=> this.pageback();
  },

  mounted() {
    window.getUserInfo = this.getUserInfo;
  },
  methods: {
    getUserInfo(params){
      // alert(params)
      if(params){
        this.doctor_id = JSON.parse(params).doctor_id;
        this.token = JSON.parse(params).token;
      }
    },
    getDate() {
      let that = this;
      let params = {
          doctor_id: that.doctor_id
      }
      http.get("/surveys/"+that.survey_id+"/questions"+'?platform_type=' +this.platform_type, {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          if(res.data.status_code == 200){
            that.sheet_id = res.data.data[0]['sheet_id'];
            that.survey_name = res.data.data[0]['name'];
            that.questions = res.data.data[0]['questions'];
          }
          that.show = true;
      });
    },
    saveSurvey(){
      let that = this;
      // alert(that.survey_name,'111')
      if(!that.survey_name){
        that.$toast('请输入问诊单名称')
      }else if(that.questions.length == 0){
        that.$toast('请新建问题')
      }else{
        let question_ids = '';
        for(let i = 0; i < that.questions.length; i++){
          if(i == 0){
            question_ids = that.questions[i]['question_id'];
          }else{
            question_ids += ',' + that.questions[i]['question_id'];
          }
        }
        let params = {
            doctor_id: that.doctor_id,
            title: that.survey_name,
            question_ids: question_ids,
        }
        if(that.sheet_id){
          params['sheet_id'] = that.sheet_id;
          http.put("/surveys/survey"+"?platform_type="+that.platform_type, params ,{headers: {"Authorization": that.token }
          }).then(function(res) {
              if(res.data.status_code == 200){
                that.pageback();
              }
          });
        }else{

          http.post("/surveys/survey"+"?platform_type="+that.platform_type, params ,{headers: {"Authorization": that.token }
          }).then(function(res) {
              if(res.data.status_code == 200){
                that.pageback();
              }
          });
        }
      }
    },
    handleDeleteQuestion(index){
      let that = this;
      that.$dialog.alert({
        title: "提示", //加上标题
        message: "确定要删除该选项吗？", //改变弹出框的内容
        showCancelButton: true //展示取水按钮
      })
      .then(() => { //点击确认按钮后的调用
        that.questions.splice(index, 1);
      })
      .catch(() => { //点击取消按钮后的调用
      })
    },
    handleEdit(child, index){
      let obj = {}
      obj['survey_name'] = this.survey_name;
      obj['questions'] = this.questions;
      obj['index'] = index;
      if(this.sheet_id){
        obj['sheet_id'] = this.sheet_id;
      }
      localStorage.setItem('local_survey_question', JSON.stringify(obj));
      this.$router.push({ path: "/bulidquestion"});
    },
    handleSort(old, index){
      let obj = this.questions[old];
      this.questions.splice(old, 1);
      this.questions.splice(index, 0, obj);
    },
    bulidQuestion(){
      let obj = {}
      obj['survey_name'] = this.survey_name;
      obj['questions'] = this.questions;
      if(this.sheet_id){
        obj['sheet_id'] = this.sheet_id;
      }
      localStorage.setItem('local_survey_question', JSON.stringify(obj));
      this.$router.push({ path: "/bulidquestion"});
    },
    pageback(){
        window.history.back();
        return true;
    }
  },
};
</script>
<style lang="scss" scoped>
.new-build-survey{
  width: 32px;
  line-break: 16px;
  font-size:16px;
  font-family: PingFang-SC-Bold;
  font-weight:bold;
  color:rgba(172,75,56,1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 14px;
}
.common-home-content-pb{
  padding-bottom: 52px;
}
.survey-name{
  padding-top: 1px;
  width: 100%;
  box-sizing: border-box;
  & > input{
    width: 100%;
    height: 36px;
    padding: 10px 15px 11px;
    font-size:15px;
    line-height: 15px;
    font-family:PingFang-SC-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    box-sizing: border-box;
    background:rgba(244,244,244,1);
    border-radius:5px;
    border: none;
  }
}
.questions-ul{
  margin-top: 21px;
  width: 100%;
  box-sizing: border-box;
  & > li{
    margin-bottom: 10px;
    padding: 15px;
    width: 100%;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    box-shadow:1px 2px 5px 1px rgba(35,25,21,0.2);
    border-radius:5px;
    position: relative;
    .question-index,
    .question-title{
      line-height: 16px;
      font-size:16px;
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    .question-index{
      color: #666;
    }
    .question-title{
      margin-top: 19px;
    }
    .del-question{
      display: block;
      width: 30px;
      line-height: 15px;
      font-size:15px;
      font-family:PingFang-SC-Bold;
      font-weight:bold;
      color:#E43C3C;
      position: absolute;
      top: 15px;
      right: 15px;
    }
    .operation-ul{
      margin-top: 30px;
      width: 100%;
      height: 15px;
      position: relative;
      display: flex;
      justify-content: space-between;
      & > li{
        display: block;
        width: 30px;
        line-height: 15px;
        font-size:15px;
        font-family:PingFang-SC-Medium;
        font-weight:500;
        color:rgba(172,76,56,1);
      }
      .color{
        color:#0792FE;
      }
      .color2{
        color:#666666;
      }
      .color3{
        color:#FD9A0C;
      }
      .color4{
        color:#AC4B38;
      }
    }
    .options-ul{
      margin-top: 16px;
      width: 100%;
      box-sizing: border-box;
      & > li{
        margin-bottom: 12px;
        padding-left: 25px;
        width: 100%;
        box-sizing: border-box;
        line-height: 15px;
        font-size:15px;
        font-family:PingFang-SC-Medium;
        font-weight:500;
        color:rgba(52,52,52,1);
        position: relative;
        label{
          display: block;
          width: 15px;
          height: 15px;
          border:1px solid rgba(204,204,204,1);
          border-radius:50%;
          margin: auto;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
        }
      }
      & > li:last-child{
        margin-bottom: 0;
      }
    }
  }
}
.answer-textarea{
  margin-top: 15px;
  width: 100%;
  height:90px;
  box-sizing: border-box;
  border:1px solid rgba(204,204,204,1);
  border-radius:5px;
}
.bulid-question-btn{
  display: block;
  margin: 210px auto 0;
  width: 155px;
  box-sizing: border-box;
  line-height: 43px;
  font-size:17px;
  font-family: PingFang-SC-Medium;
  font-weight:500;
  color:rgba(255,255,255,1);
  text-align: center;
  background:rgba(172,76,56,1);
  border-radius:4px;
}
.fixed-button{
  width: 100%;
  box-sizing: border-box;
  padding: 3px 15px;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #fff;
  & > button{
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size:17px;
    font-family: PingFang-SC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    background:rgba(172,76,56,1);
    border-radius:4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/buildsurvey.vue